module.exports = __webpack_public_path__ + "static/media/greyhound.589afd35.webp";